export * from './IconDocAdd';
